import { render, staticRenderFns } from "./SPRTickCrossWarning.vue?vue&type=template&id=4c168535&scoped=true"
import script from "./SPRTickCrossWarning.vue?vue&type=script&lang=ts"
export * from "./SPRTickCrossWarning.vue?vue&type=script&lang=ts"
import style0 from "./SPRTickCrossWarning.vue?vue&type=style&index=0&id=4c168535&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c168535",
  null
  
)

export default component.exports